<template>
    <layout :title="`Contract Details: ${invoices[0].contract_number}`">
        <contract-detail-listings :invoices="invoices"></contract-detail-listings>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import ContractDetailListings from "@/Components/CottonseedPayments/ContractDetailListings";

export default {
    components: {ContractDetailListings, Layout},
    props: {
        invoices: {
            type: Array,
            default: []
        },
    },
}
</script>
